import { mediaData } from '@/mocks/home';

const coverImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20entertainment%20news%20visual%20with%20crimson%20red%20accents%2C%20breaking%20news%20editorial%20style%2C%20dramatic%20lighting%20on%20dark%20background%2C%20professional%20media%20thumbnail%2C%20mysterious%20atmosphere&width=600&height=340&seq=media-cover-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20live%20streaming%20studio%20visual%20with%20warm%20golden%20highlights%2C%20entertainment%20media%20cover%2C%20cinematic%20dark%20background%2C%20professional%20editorial%20aesthetic&width=600&height=340&seq=media-cover-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Mysterious%20dark%20investigative%20journalism%20visual%20with%20red%20and%20amber%20geometric%20accents%2C%20entertainment%20media%20cover%2C%20cinematic%20dark%20style%2C%20professional%20editorial&width=600&height=340&seq=media-cover-3&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          媒体聚焦
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选深度内容，解码娱乐圈背后的故事
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 border border-background-200/60 hover:border-primary-500/30 rounded-lg overflow-hidden transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={coverImages[item.id]}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-xs bg-background-50/90 text-foreground-800 px-2 py-0.5 rounded">
                    {item.duration}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}